var _FactoryModelState_updater, _FactoryModelState_currentPromise, _FactoryModelState_waitForPromise;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import CancellablePromise from '../Promises/CancellablePromise';
import isUndefinedOrNull from '../TypeHelpers/isUndefinedOrNull';
import BaseModelState from './BaseModelState';
export default class FactoryModelState extends BaseModelState {
    constructor(promiseOrValueFactory, updateNow = true) {
        super();
        _FactoryModelState_updater.set(this, void 0);
        _FactoryModelState_currentPromise.set(this, void 0);
        _FactoryModelState_waitForPromise.set(this, (then) => {
            if (isUndefinedOrNull(__classPrivateFieldGet(this, _FactoryModelState_currentPromise, "f"))) {
                return Promise.resolve().then(then);
            }
            return __classPrivateFieldGet(this, _FactoryModelState_currentPromise, "f")
                .then(then)
                .finally((promise, cancelled) => {
                if (cancelled) {
                    __classPrivateFieldGet(this, _FactoryModelState_waitForPromise, "f").call(this, then);
                }
            });
        });
        __classPrivateFieldSet(this, _FactoryModelState_updater, (async () => {
            this.setValue(await promiseOrValueFactory());
        }).bind(this), "f");
        if (updateNow) {
            this.update();
        }
    }
    subscribe(postCallback, preCallback) {
        const key = super.subscribeCore(postCallback, preCallback, false);
        if (__classPrivateFieldGet(this, _FactoryModelState_currentPromise, "f")) {
            __classPrivateFieldGet(this, _FactoryModelState_waitForPromise, "f").call(this, () => postCallback(this.value));
        }
        else {
            postCallback(this.value);
        }
        return key;
    }
    /** Gets the current value of the ModelState */
    get value() {
        return this.getValue();
    }
    set value(value) {
        this.setValue(value);
    }
    update() {
        if (__classPrivateFieldGet(this, _FactoryModelState_currentPromise, "f")) {
            __classPrivateFieldGet(this, _FactoryModelState_currentPromise, "f").cancel();
        }
        __classPrivateFieldSet(this, _FactoryModelState_currentPromise, new CancellablePromise(__classPrivateFieldGet(this, _FactoryModelState_updater, "f").call(this)), "f");
    }
}
_FactoryModelState_updater = new WeakMap(), _FactoryModelState_currentPromise = new WeakMap(), _FactoryModelState_waitForPromise = new WeakMap();
